export const DisclaimerWorldlineOne: string[] = [
  "The monthly cost is invoiced monthly in advance.",
  "The cost of Visa, MasterCard, Maestro, DinersClub, UnionPay and JCB is deducted from the payout you receive.",
  "Payment of redeemed credit card transactions takes place in local currency the banking day after the credit card transaction has been completed in the payment terminal.",
  "The binding period is 24 months and the agreement then continues with 3 months' notice",
  "Acquiring prices stated in contract cover both purchase and refund transactions",
];
